/**
 * Constrói o payload para criar um cupom Stripe a partir do formulário admin.
 * Retorna { ok: false, error } se inválido, ou { ok: true, payload } pronto pra API.
 */
export function buildStripeCouponPayload(form) {
  if (!form?.code?.trim()) return { ok: false, error: 'Código é obrigatório' };

  const percentOff = parseInt(form.percentOff, 10);
  if (!Number.isFinite(percentOff) || percentOff < 1 || percentOff > 100) {
    return { ok: false, error: 'Desconto deve estar entre 1 e 100%' };
  }

  if (!['once', 'repeating', 'forever'].includes(form.duration)) {
    return { ok: false, error: 'Duração inválida' };
  }

  const payload = {
    percentOff,
    duration: form.duration,
    name: form.name?.trim() || form.code.trim().toUpperCase(),
  };

  if (form.duration === 'repeating') {
    const months = parseInt(form.durationInMonths, 10);
    if (!Number.isFinite(months) || months < 1) {
      return { ok: false, error: 'Informe quantos meses para duração recorrente' };
    }
    payload.durationInMonths = months;
  }

  if (form.maxRedemptions) {
    const max = parseInt(form.maxRedemptions, 10);
    if (!Number.isFinite(max) || max < 1) {
      return { ok: false, error: 'Limite de usos inválido' };
    }
    payload.maxRedemptions = max;
  }

  return { ok: true, payload };
}
